import React, { useEffect, useState } from "react";
import axios from "axios";
import { useUser } from "../Contexts/UserContext";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const BackendExcelTable = ({ page }) => {
  const { user } = useUser();
  const [data, setData] = useState([]); // State for table data
  const [headers, setHeaders] = useState([]); // State for table headers
  const { ClientId, CompCode } = user;

  // Fetch Excel data from backend
  const fetchExcelData = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/adv/ReadExcel/${ClientId}/${page}`
      );
      if (response.data.success === 1) {
        const jsonData = response.data.data;
        if (jsonData.length > 0) {
          setHeaders(jsonData[0]); // First row as headers
          setData(jsonData.slice(1)); // Remaining rows as data
        }
      } else {
        console.error("Failed to fetch Excel data:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching Excel data:", error);
    }
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  return (
    <div style={{ margin: "20px" }}>
      {data.length > 0 ? (
        <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th
                  key={index}
                  style={{ padding: "8px", backgroundColor: "#f0f0f0" }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    style={{ padding: "8px", textAlign: "center" }}
                  >
                    {cell || "-"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No data to display. Please try again later.</p>
      )}
    </div>
  );
};

export default BackendExcelTable;
